import React from 'react';
import PropTypes from 'prop-types';
import { useLanguage } from '@contexts/LanguageContext';
import Icon from '@components/Icon/Icon';

/**
 * Component for managing select field options
 */
const OptionsManager = ({ options, onChange, disabled = false }) => {
  const { t } = useLanguage();

  const handleAddOption = (value) => {
    if (!value.trim()) return;

    if (options.includes(value)) {
      alert(t('borrowingFields.manager.optionAlreadyExists') || 'This option already exists');
      return;
    }

    onChange([...options, value]);
  };

  const handleRemoveOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    onChange(newOptions);
  };

  return (
    <div className="form-group">
      <label>{t('borrowingFields.manager.options') || 'Options'} *</label>
      <div className="options-list">
        {options.map((option, index) => (
          <div key={index} className="option-item">
            <span>{option}</span>
            {!disabled && (
              <button
                type="button"
                onClick={() => handleRemoveOption(index)}
                className="btn-remove"
              >
                <Icon icon="times" />
              </button>
            )}
          </div>
        ))}
      </div>
      {!disabled && (
        <div className="add-option">
          <input
            type="text"
            placeholder={t('borrowingFields.manager.addOption') || 'Add option...'}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                const value = e.target.value.trim();
                if (value) {
                  handleAddOption(value);
                  e.target.value = '';
                }
              }
            }}
            className="form-control"
          />
        </div>
      )}
    </div>
  );
};

OptionsManager.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default OptionsManager;
